import React from 'react';
import {Divider} from "antd";

// Note. More than one button can be fed in using a React snippet.
// E.g. <>
//          <Button></Button>
//          <Button></Button>
//      </>

const PageHeader = ({ title, subtitle, buttons, sticky = false }) => {
    return (
        <div className={sticky ? `ch-page-heading-sticky` : ''}>
            <div className={`ch-page-heading-wrapper`}>
                <div>
                    <h2>{title}</h2>
                    {subtitle && <p>{subtitle}</p>}
                </div>
                <div className={'ch-page-heading-buttons'}>
                    {buttons}
                </div>
            </div>
            {sticky &&
                <Divider className={'ch-divider'} />
            }
        </div>
    );
};

export default PageHeader;